const fileRoutes = [
  {
    name: 'files',
    path: '/files',
    children: [{ name: 'directory', path: '/*basepath' }],
  },
  { name: 'file', path: '/file/*basepath?:viaPreview' },
];

const sharedFileRoutes = [
  { name: 'file', path: '/:sharedFileId<[\\w\\d]+={0,2}>?:ini?:v' },
];

const projectRoutes = [
  ...fileRoutes,
  { name: 'version', path: '/v/:contributionId', children: fileRoutes },
  { name: 'contribution', path: '/contributions/:contributionId' },
  { name: 'conflicts', path: '/conflicts' },
  { name: 'issues', path: '/issues' },
  { name: 'issue', path: '/issues/:issueSlug' },
  {
    name: 'settings',
    path: '/settings',
    children: [
      { name: 'teams', path: '/teams' },
      { name: 'general', path: '/general' },
      { name: 'admin', path: '/admin' },
    ],
  },
];

const storyRoutes = [{ name: 'edit', path: '/edit' }];

const homeRoutes = [
  // websites
  {
    name: 'community',
    path: 'community',
    forwardTo: 'home.community.featured',
    children: [
      { name: 'article', path: '/social-gets-productive' },
      { name: 'featured', path: '/featured' },
      { name: 'topics', path: '/topics' },
      { name: 'projects', path: '/projects' },
      { name: 'tasks', path: '/tasks' },
      { name: 'members', path: '/members' },
    ],
  },
  { name: 'marketplace', path: 'marketplace' },
  {
    name: 'company',
    path: 'company',
    children: [
      { name: 'about', path: '/about' },
      { name: 'story', path: '/story' },
      {
        name: 'careers',
        path: '/careers',
        children: [{ name: 'position', path: '/:position' }],
      },
    ],
  },
  { name: 'pricing', path: 'pricing' },
  { name: 'privacy', path: 'privacy' },
  { name: 'cookies', path: 'cookies' },
  { name: 'terms', path: 'terms' },
  { name: 'features', path: 'features' }, // figure out what to do.
  { name: 'formats', path: 'file-formats' }, // figure out what to do.
  // platform
  {
    name: 'contribute',
    path: 'contribute',
    forwardTo: 'home.community.featured',
    children: [
      {
        name: 'projects',
        path: '/projects',
        forwardTo: 'home.community.projects',
      },
      { name: 'issues', path: '/issues', forwardTo: 'home.community.tasks' },
    ],
  },
  {
    name: 'connect',
    path: 'connect',
    children: [
      { name: 'conversations', path: '/conversations' },
      {
        name: 'members',
        path: '/members',
        forwardTo: 'home.community.members',
      },
      { name: 'organisations', path: '/organisations' },
    ],
  },
  {
    name: 'discover',
    path: 'discover',
    children: [
      { name: 'topics', path: '/topics', forwardTo: 'home.community.topics' },
      { name: 'stories', path: '/stories' },
    ],
  },
  { name: 'home', path: 'home' }, // always maps to "logged out" landing page.
  { name: 'notifications', path: 'notifications' },
  { name: 'gateway', path: 'gateway?:utoken&:next' },
  { name: 'invite', path: 'invite/:inviteId/:referrerUserId/:token&:next' },
  { name: 'signUp', path: 'sign-up?:next?:id?:p' },
  { name: 'signUpOrganisation', path: 'sign-up-organisation?:next?:id' },
  { name: 'signUpManufacturer', path: 'sign-up-manufacturer' },
  { name: 'signIn', path: 'sign-in?:next' },
  {
    name: 'newPassword',
    path: 'new-password/:username<@[^/?]+>/:expiry/:hmac',
  },
  { name: 'newStory', path: 'new-story' },
  { name: 'newProject', path: 'new-project' },
  { name: 'importProject', path: 'import-project' },
  { name: 'newInitiative', path: 'new-organisation' },
  { name: 'search', path: 'search?:q' },
  { name: 'redirect', path: 'redirect' },
];

const manufacturingPortal = [
  { name: 'rfq', path: '/rfq/:rfqId' },
  { name: 'quote', path: '/quote/:quoteId' },
  { name: 'order', path: '/order/:orderId' },
];

const roleSensitiveWorkspaceRoutes = [
  {
    name: 'rfqs',
    path: '/rfqs?:p&:order&:sort&:filters&:intermediator',
  },
  {
    name: 'quotes',
    path: '/quotes',
  },
  { name: 'orders', path: '/orders' },
];

export const routes = [
  { name: 'home', path: '/', children: homeRoutes },
  {
    name: 'profile',
    path: '/:profile<@[^/?]+>',
    children: [
      { name: 'story', path: '/stories/:slug', children: storyRoutes },
      { name: 'collection', path: '/collection/:slug' },
      { name: 'shared', path: '/shared', children: sharedFileRoutes },
      { name: 'project', path: '/:slug', children: projectRoutes },
      { name: 'invitations', path: '/invitations' },
      { name: 'projects', path: '/projects' },
      { name: 'stories', path: '/stories' },
      { name: 'threads', path: '/threads' },
      {
        name: 'collections',
        path: '/collections',
        // children: [
        //   {
        //     name: 'collection',
        //     path: '/:slug',
        //   },
        // ],
      },
    ],
  },
  {
    name: 'initiative',
    path: '/:initiative<\\+[^/?]+>?:thread',
    children: [
      {
        name: 'services',
        path: '/services',
        children: [
          {
            name: 'editFabrication',
            path: '/edit-fabrication-services',
          },
        ],
      },
      { name: 'projects', path: '/projects' },
      { name: 'stories', path: '/stories' },
      { name: 'story', path: '/stories/:slug', children: storyRoutes },
      { name: 'collection', path: '/collections/:slug' },
      { name: 'shared', path: '/shared', children: sharedFileRoutes },
      { name: 'project', path: '/:slug', children: projectRoutes },
      {
        name: 'forum',
        path: '/forum',
        children: [
          {
            name: 'categorySlug',
            path: '/category/:categoryId/:categorySlug',
          },
          { name: 'category', path: '/category/:categoryId' },
          { name: 'threadSlug', path: '/thread/:threadId/:threadSlug' },
          { name: 'thread', path: '/thread/:threadId' },
        ],
      },
    ],
  },
  {
    name: 'channel',
    path: '/topic/:channel',
    children: [
      {
        name: 'stories',
        path: '/stories',
      },
      {
        name: 'threads',
        path: '/threads',
      },
      {
        name: 'collections',
        path: '/collections',
      },
      {
        name: 'settings',
        path: '/settings',
        children: [
          { name: 'general', path: '/general' },
          { name: 'teams', path: '/teams' },
        ],
      },
    ],
  },
  {
    name: 'manufacturing',
    path: '/manufacturers',
    children: [{ name: 'results', path: '/results?pc&mc&p&m' }],
  },
  {
    name: 'viewer',
    path: '/viewer/:fileID<[\\w\\d]+={0,2}>?:filename?:isClassicViewer',
  },
  { name: 'share-file', path: '/share-file' },
  {
    name: 'make-part',
    path: '/make-part',
    children: [
      { name: 'file', path: '/:sharedFileId<[\\w\\d]+={0,2}>?:ini?:v' },
    ],
  },
  ...manufacturingPortal,
  {
    name: 'intermediator',
    path: '/intermediator',
    children: manufacturingPortal,
  },
  {
    name: 'manufacturer',
    path: '/manufacturer/:manufacturerId',
    children: manufacturingPortal,
  },
  {
    name: 'workspace',
    path: '/workspace/:spacePath',
    children: [
      { name: 'spaceFiles', path: '/files' },
      { name: 'spaceProjects', path: '/projects' },
      ...roleSensitiveWorkspaceRoutes,
      {
        name: 'intermediator',
        path: '/intermediator',
        children: roleSensitiveWorkspaceRoutes,
      },
      {
        name: 'manufacturer',
        path: '/manufacturer/:manufacturerId',
        children: roleSensitiveWorkspaceRoutes,
      },
      {
        name: 'spaceSettings',
        path: '/settings',
        children: [
          { name: 'teams', path: '/teams' },
          { name: 'billing', path: '/billing' },
          { name: 'account', path: '/account' },
          { name: 'notifications', path: '/notifications' },
        ],
      },
    ],
  },
  {
    name: 'new-quote',
    path: '/new-quote/:customerSlug<[@|+]{1}[^\\/?]+>',
  },
];

if (ENV_NAME !== 'production') {
  routes.push({ name: 'test', path: '/test' });
}
